<template>
    <v-container>
        <history-number-summary
            v-model="tryoutHistory"
            :routeInformation="routeInformation"
            class="mx-4"
        ></history-number-summary>

        <question-explanation-filter
            v-if="tryoutHistory"
            :tryout-hash="tryoutHistory.hash"
            class="my-4"
        ></question-explanation-filter>

        <maintenance-message></maintenance-message>

        <question-explanation-pagination class="my-4"></question-explanation-pagination>

        <video-survey class="my-4" v-if="$store.get('enrollment/selected@id') == 45"></video-survey>

        <tryout-hiding-description></tryout-hiding-description>

        <question-explanation></question-explanation>

        <question-explanation-pagination class="my-4"></question-explanation-pagination>
    </v-container>
</template>

<script>
import QuestionExplanation from '@/components/dashboard/explanation/QuestionExplanation'
import TryoutHidingDescription from '@/components/dashboard/explanation/TryoutHidingDescription'
import QuestionExplanationPagination from '@/components/dashboard/explanation/QuestionExplanationPagination'
import HistoryNumberSummary from '@/components/dashboard/explanation/HistoryNumberSummary'
import QuestionExplanationFilter from '@/components/dashboard/explanation/QuestionExplanationFilter'
import VideoSurvey from './VideoSurvey.vue'
import MaintenanceMessage from '@/components/dashboard/maintenance/MaintenanceMessage.vue'

export default {
    components: {
        QuestionExplanation,
        TryoutHidingDescription,
        QuestionExplanationPagination,
        HistoryNumberSummary,
        VideoSurvey,
        QuestionExplanationFilter,
        MaintenanceMessage,
    },

    data: () => ({
        routeInformation: null,
        tryoutHistory: null,
    }),

    created() {
        this.$store.set('explanation/historyHash', this.$route.params.history_hash)
        this.$store.dispatch('explanation/getData')
    },

    destroyed() {
        this.$store.dispatch('explanation/reset')
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.routeInformation = { to, from }
        })
    }
}
</script>
